import {createBrowserHistory} from 'history';

const history = createBrowserHistory()

export default history



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/history.js